import { render, staticRenderFns } from "./handhome4.vue?vue&type=template&id=01f7c6b4&scoped=true"
import script from "./handhome4.vue?vue&type=script&lang=js"
export * from "./handhome4.vue?vue&type=script&lang=js"
import style0 from "./handhome4.vue?vue&type=style&index=0&id=01f7c6b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f7c6b4",
  null
  
)

export default component.exports